import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, TemplateRef, ViewChild, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { MsalService } from '@azure/msal-angular';
import { forkJoin, firstValueFrom } from 'rxjs';
import { EditorComponent } from 'src/app/editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { SearchUsersComponent } from '../search-users/search-users.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DynamicGridConfig, DynamicGridClauses, DynamicGridReport, DynamicGridSettings, DynamicGridTrail } from 'src/app/support/models/dynamic-grid.model';

@Component({
  selector: 'app-pre-actions',
  templateUrl: './pre-actions.component.html',
  styleUrls: ['./pre-actions.component.scss']
})

export class PreActionsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() activityData: boolean;
  @Output() valueChange = new EventEmitter<{ action: any[] }>;

  dateCustomClasses: DatepickerDateCustomClasses[];
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  event = { isUserInput: true, source: { _selected: true, } }
  idMapping: Record<string, string> = { 'CR': this?.qualityService?.activity?.crId, 'CAPA': this.qualityService.activity.capaId, 'DV': this.qualityService.activity.dvId, 'AU': this.qualityService.activity.auId, 'IN': this.qualityService.activity.inId, 'QI': this.qualityService.activity.qiId, 'CC': this.qualityService.activity.ccId };

  action: any = {};
  objForDocuments: {};
  isFromDynamicClick: boolean = false;

  buttonList: any = [];
  reviewStatus: any = [];

  isProcessing: boolean = false;
  isBusinessAreaEmpty: boolean = false;
  visibleEditButton: boolean = false;
  isESignRequired: boolean = false;
  isReasonSignReqd: boolean = false;
  hidePassword: boolean = true;
  isAdEnabled: boolean = false;
  isPlanFrozen: boolean = false;
  isExecutionFrozen: boolean = false;

  businessAreaName: any;
  popupTitle: string = '';
  buttonLabel: string = '';
  reason: string = '';
  userName: string = '';
  password: any = "";
  selectedStatus: any = null;
  currentModuleId: string

  actionTypeList: any = [];
  departmentList: any = [];
  designationList: any = [];
  docTypeList: any = [];
  reviewerList: any = [];
  approverList: any = [];
  deferReviewerList: any = [];
  deferApproverList: any = [];
  qualityUserList: any = [];
  requestedAtList: any = [];
  businessAreaList: any = [];

  actionTypeDropdown: any = [];
  departmentDropdown: any = [];
  designationDropdown: any = [];
  docTypeDropdown: any = [];
  reviewerDropdown: any = [];
  approverDropdown: any = [];
  deferReviewerDropdown: any = [];
  deferApproverDropdown: any = [];
  qualityUserDropdown: any = [];
  requestedAtDropdown: any = [];
  businessAreaDropdown: any = [];

  selectedActionType: any = [];
  selectedBusinessArea: any = [];

  oddActionType: any = null;
  oddDepartment: any = null;
  oddDocType: any = null;
  oddReviewer: any = null;
  oddApprover: any = null;
  oddPlanReviewer: any = null;
  oddPlanApprover: any = null;
  oddDeferReviewer: any = null;
  oddDeferApprover: any = null;
  oddRequestedAt: any = null;

  actionTypeSearchText: string = '';
  departmentSearchText: string = '';
  docTypeSearchText: string = '';
  reviewerSearchText: string = '';
  approverSearchText: string = '';
  planReviewerSearchText: string = '';
  planApproverSearchText: string = '';
  deferReviewerSearchText: string = '';
  deferApproverSearchText: string = '';
  requestedAtSearchText: string = '';
  businessAreaSearchText: string = '';

  constructor(
    readonly router: Router,
    readonly dialog: MatDialog,
    readonly qualityService: qmsService,
    readonly appService: AppService,
    readonly message: messageService,
    readonly paginationService: PaginationService,

    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly authService: MsalService,
    private readonly elem: ElementRef
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  };

  gridConfig!: DynamicGridConfig;
  gridClause!: DynamicGridClauses;
  gridTrail!: DynamicGridTrail;
  gridReport!: DynamicGridReport;
  gridSettings!: DynamicGridSettings;

  getCall(): void {
    this.gridConfig = {
      gridName: 'PRE_ACTIONS',
      groupId: 0,
      showAddButton: this.message.showPreActionsActionButtons,
      showEditIcon: this.message.showPreActionsActionButtons,
      showDeleteIcon: false,
      showAuditTrail: true,
      buttonsTooltipSubName: 'Preliminary Action',
    };

    this.gridClause = {
      refNo: this.qualityService.activityId
    };

    this.gridTrail = {
      gridName: 'PRE_ACTIONS',
      refKey: 'ACTION_ID',
      activityRefNo: this.qualityService.activityId,
      trailName:
        `${this.qualityService.moduleName} Preliminary Action Audit Trail ` +
        `[${this.idMapping[this.qualityService.moduleName]}]`
    };

    this.gridReport = {
      reportName:
        `${this.qualityService.moduleName} Preliminary Action Report ` +
        `[${this.idMapping[this.qualityService.moduleName]}]`,
      reportType: 'Dynamic',
      excludeGroupId: true,
    };

    this.gridSettings = {
      module: this.qualityService.moduleName,
      groupId: 0
    };
  }

  public onAddEmit(): void {
    this.openAddPopup();
  }

  public onEditEmit(event: { mode: string; id: number; obj: any }): void {
    this.openEditPopup(event.obj, event.id, event.mode);
  }

  grid: any = [];
  public onReorderEmit(event: { grid: any }): void {
    this.grid = event.grid;
    this.openReorderPopup();
  }

  public onSettingsEmit() {
    this.getDynamicLabel();
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.isAdEnabled = localStorage.getItem("adEnabled") == 'Y';

    this.isProcessing = true;

    const groupId = this.qualityService.selectedGroup;
    const module = this.qualityService.moduleName;

    const getDocType$ = this.appService.getCodeListsByGroup("DOCUMENT_TYPE");
    const getActionType$ = this.appService.getCodeListsByGroup("ACTION_TYPE");
    const getReviewer$ = this.appService.getQmsActiveGroupUsers(groupId, module, 'Action Reviewer');
    const getApprover$ = this.appService.getQmsActiveGroupUsers(groupId, module, 'Action Approver');
    const getDeferReviewer$ = this.appService.getQmsActiveGroupUsers(groupId, module, 'Action Deferred Reviewer');
    const getDeferApprover$ = this.appService.getQmsActiveGroupUsers(groupId, module, 'Action Deferred Approver');
    const getQmsUserList$ = this.appService.getOneQmsUsersWithRolesVwDetails('QMS');
    const getBusinessAreaList$ = this.appService.getQmsBusinessAreasByModule(module);

    forkJoin([
      getDocType$,
      getActionType$,
      getReviewer$,
      getApprover$,
      getDeferReviewer$,
      getDeferApprover$,
      getQmsUserList$,
      getBusinessAreaList$
    ]).subscribe(([docType, actionType, reviewer, approver, deferReviewer, deferApprover, qmsUserList, businessArea]) => {

      this.departmentList = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
      this.selectBoxForDepartment();

      this.designationList = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
      this.selectBoxForDesignation();

      this.docTypeList = docType;
      this.selectBoxForDocType();

      this.actionTypeList = actionType;
      this.selectBoxForActionType();

      this.reviewerList = reviewer;
      this.selectBoxForReviewer();

      this.approverList = approver;
      this.selectBoxForApprover();

      this.deferReviewerList = deferReviewer;
      this.selectBoxForDeferReviewer();

      this.deferApproverList = deferApprover;
      this.selectBoxForDeferApprover();

      const x: any = qmsUserList;
      for (const y of x) y.isActive = y.isActive == "Y";
      this.qualityUserList = x;
      this.selectBoxForUserList();

      this.requestedAtList = businessArea;
      this.selectBoxForRequestedAt();

      this.isProcessing = false;

      if (this.qualityService.activityId != null && this.qualityService.activityId != "") {
        if (this.activityData) {
          this.getCall();
        } else {
          this.openEditPopup(this.message.taskLevelData, 0, "edit");
        }
      }
    });

    this.getDynamicLabel();
  }

  private selectBoxForDocType(): void {
    this.docTypeList = this.docTypeList?.map((docType: any) => ({
      valueExp: docType.codelistCode,
      displayExp: docType.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  private selectBoxForActionType(): void {
    this.actionTypeDropdown = this.actionTypeList?.map((type: any) => ({
      valueExp: type?.codelistCode,
      displayExp: type?.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onActionTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('action-type', this.selectedActionType);
        this.isAllActionTypeSelected = this.actionTypeDropdown.length == this.selectedActionType.length;
      })
    }
  }

  private selectBoxForDesignation(): void {
    this.designationDropdown = this.designationList?.map((docType: any) => ({
      valueExp: docType.codelistCode,
      displayExp: docType.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  private selectBoxForDepartment(): void {
    this.departmentDropdown = this.departmentList?.map((dept: any) => ({
      valueExp: dept?.codelistCode,
      displayExp: dept?.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onDepartmentSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('department', item);
    }
  }

  private selectBoxForReviewer(): void {
    this.reviewerDropdown = this.reviewerList?.map((reviewer: any) => ({
      valueExp: reviewer?.userId,
      displayExp: reviewer?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onPlanReviewerSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('p-plan-reviewer', item);
    }
  }

  public onReviewerSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('p-reviewer', item);
    }
  }

  private selectBoxForApprover(): void {
    this.approverDropdown = this.approverList?.map((approver: any) => ({
      valueExp: approver?.userId,
      displayExp: approver?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onPlanApproverSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('p-plan-approver', item);
    }
  }

  public onApproverSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('p-approver', item);
    }
  }

  private selectBoxForDeferReviewer(): void {
    this.deferReviewerDropdown = this.deferReviewerList?.map((dr: any) => ({
      valueExp: dr?.userId,
      displayExp: dr?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onDeferReviewerSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('p-defer-reviewer', item);
    }
  }

  private selectBoxForDeferApprover(): void {
    this.deferApproverDropdown = this.deferApproverList?.map((da: any) => ({
      valueExp: da?.userId,
      displayExp: da?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onDeferApproverSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('p-defer-approver', item);
    }
  }

  private selectBoxForUserList(): void {
    this.qualityUserDropdown = this.qualityUserList?.map((user: any) => ({
      valueExp: user?.userId,
      displayExp: user?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  };

  private selectBoxForRequestedAt(): void {
    this.requestedAtDropdown = this.requestedAtList?.map((x: any) => ({
      valueExp: x?.taskRequestedAt,
      displayExp: x?.taskRequestedAt,
      listOfBusinessArea: x.listOfBusinessArea
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []

    const businessArea = this.requestedAtDropdown.find((task: any) => task.valueExp == this.action.actionAt);
    this.isBusinessAreaEmpty = !businessArea?.listOfBusinessArea;
  }

  public onRequestedAtSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('action-at', item)
      if (item) {
        this.businessAreaName = item.displayExp;
        const getBusinessArea = this.requestedAtList?.find((x: any) => x.taskRequestedAt == item.valueExp);
        this.isBusinessAreaEmpty = !(getBusinessArea?.listOfBusinessArea?.trim());
        [this.businessAreaDropdown, this.selectedBusinessArea, this.isAllBusinessAreaSelected] = [[], this.isBusinessAreaEmpty ? '' : [], false];
        this.businessAreaList = getBusinessArea?.listOfBusinessArea?.split(',');
        this.selectBoxForCoreBusinessAreaName();

      } else {
        this.businessAreaDropdown = [];
        this.businessAreaList = [];
        this.businessAreaName = '';
      }
    }
  }

  private selectBoxForCoreBusinessAreaName(): void {
    this.businessAreaDropdown = this.businessAreaList?.map((businessArea: any) => ({
      valueExp: businessArea,
      displayExp: businessArea
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  public onBusinessAreaSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('business-area', this.selectedBusinessArea)
        this.isAllBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length;
      });
  }

  public getDescription(module: string): string {
    if (module == 'CAPA') {
      return 'qualityService.activity.capaDescription';
    } else {
      return '';
    }
  }

  public handleDropDownValidation(fieldId: string, selectedItems: any[] | string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = fieldId == 'business-area';
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  public focusSearch(value: any): void {
    setTimeout(() => {
      let requiredElement = document.getElementById(value); requiredElement?.focus();
    }, 0)
  };

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('performOperationPopup', { static: true }) performOperationPopup: TemplateRef<any>;
  visiblePerformOperationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('clobPopup', { static: true }) clobPopup: TemplateRef<any>;
  visibleClobPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '1px', left: '7%' },
    maxWidth: '91vw',
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  performOperationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  clobPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  $commonConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    adaptivePosition: true,
  }

  $targetDateConfig = {
    ...this.$commonConfig,
    minDate: new Date(),
    maxDate: new Date(this.qualityService.activity.expcetedClosureOn),
  }

  $dateConfig = {
    ...this.$commonConfig,
    maxDate: new Date(),
  }

  $dateTimeConfig = {
    ...this.$commonConfig,
    dateInputFormat: this.dateFormat + " HH:mm:ss ",
    maxDate: new Date(),
  }

  public $getDynamicConfig() {
    return {
      ...this.$commonConfig,
      minDate: new Date(this.action.createdOn),
      maxDate: new Date()
    }
  }

  public openAddPopup(): void {
    this.buttonList = ["Save", "Cancel"];
    this.action = {};
    this.selectedActionType = [];
    this.visibleEditButton = false;
    this.popupTitle = "Create Preliminary Action";
    this.qualityService.getQmsActionDataUsingById = {};
    this.action.actionDescription = '';
    this.isPlanFrozen = this.isExecutionFrozen = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  };

  openEditPopup(data: any, id: any, mode: string) {
    this.message.subModuleId = data.ACTION_ID;
    if (id == 0 || id == 1) {
      this.action = {};
      this.buttonList = [];
      this.isProcessing = true;

      this.appService.getPreActionById(data.ACTION_ID).subscribe((data: any) => {
        this.objForDocuments = { id: data.actionId, pagename: "PreAction" };

        data.actionPerformed = data.actionPerformed == "Y";
        data.createdOn = new Date(data.createdOn);
        data.targetDate = new Date(data.targetDate);
        data.actualActionCompletedOn = data.actualActionCompletedOn ? new Date(data.actualActionCompletedOn) : null;
        data.actionCompletedOn = data.actionCompletedOn ? new Date(data.actionCompletedOn) : null;

        this.action = data;
        this.popupTitle = "Update Preliminary Action";
        this.selectBoxForRequestedAt();
        this.setNonUserDropdown(this.action);
        this.setReviewerApproverDropdown(this.action);
        this.setDeferReviewerApproverDropdown(this.action);
        this.setAesthetic(this.action);

        const obj = { actionId: this.action.actionId, }
        this.appService.getPreActionButtons(obj).subscribe((data1: any) => {
          if (data1.labelsResult) {
            data1.labelsResult = data1.labelsResult + ",Cancel";
            this.buttonList = data1.labelsResult.split(",");
          } else {
            data1.labelsResult = "Cancel";
            this.buttonList = data1.labelsResult.split(",");
          }

          this.visibleEditButton = true;
          mode == 'edit' && (this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig));
          this.isProcessing = false;
        });
      });
    }
  };

  private setNonUserDropdown(action: any): void {

    if (action.actionAt) {
      const getBusinessArea = this.requestedAtDropdown.find((x: any) => x.valueExp == action.actionAt);
      this.onRequestedAtSelect(this.event, { valueExp: action.actionAt, displayExp: action.actionAt })

      if (getBusinessArea) {
        this.businessAreaList = getBusinessArea?.listOfBusinessArea?.split(',');
        this.oddRequestedAt = null;
      } else {
        this.oddRequestedAt = action.actionAt;
        this.requestedAtDropdown.push({ valueExp: action.actionAt, displayExp: action.actionAt });
      }
    }

    setTimeout(() => {
      if (action.coreBusinessArea) this.selectedBusinessArea = this.isBusinessAreaEmpty ? action.coreBusinessArea : action.coreBusinessArea?.split(',') ?? [];
      setTimeout(() => { if (!this.isBusinessAreaEmpty) this.isAllBusinessAreaSelected = this.selectedBusinessArea.length == this.businessAreaDropdown.length })
    });

    if (action.actionType) {
      this.selectedActionType = action.actionType?.split(",");
    } else {
      this.selectedActionType = [];
    }
    setTimeout(() => this.isAllActionTypeSelected = this.selectedActionType.length == this.actionTypeDropdown.length);

    if (action.assignedToDepartment) {
      const matchingDepartment = this.departmentDropdown?.find((x: any) => x.valueExp === action.assignedToDepartment);
      if (matchingDepartment) {
        this.oddDepartment = null;
      } else {
        this.oddDepartment = action.assignedToDepartment;
        this.departmentDropdown.push({ valueExp: action.assignedToDepartment, displayExp: action.assignedToDepartment })
      }
    }
  }

  private setReviewerApproverDropdown(action: any): void {
    if (action.reviewedByUser) {
      const matchingReviewer = this.reviewerDropdown?.find((x: any) => x.valueExp == action.reviewedByUser);
      if (matchingReviewer) {
        this.oddReviewer = null;
      } else {
        this.oddReviewer = action.reviewedByUser;
        this.reviewerDropdown.push({ valueExp: action.reviewedByUser, displayExp: action.reviewer });
      }
    }

    if (action.approvedByUser) {
      const matchingApprover = this.approverDropdown?.find((x: any) => x.valueExp == action.approvedByUser);
      if (matchingApprover) {
        this.oddApprover = null;
      } else {
        this.oddApprover = action.approvedByUser;
        this.approverDropdown.push({ valueExp: action.approvedByUser, displayExp: action.approver });
      }
    }
  }

  private setDeferReviewerApproverDropdown(action: any): void {
    if (action.deferReviewedByUser) {
      const matchingDeferReviewer = this.deferReviewerDropdown?.find((x: any) => x.valueExp == action.deferReviewedByUser);
      if (matchingDeferReviewer) {
        this.oddDeferReviewer = null;
      } else {
        this.oddDeferReviewer = action.deferReviewedByUser;
        this.deferReviewerDropdown.push({ valueExp: action.deferReviewedByUser, displayExp: action.deferReviewer });
      }
    }

    if (action.deferApprovedByUser) {
      const matchingDeferApprover = this.deferApproverDropdown?.find((x: any) => x.valueExp == action.deferApprovedByUser);
      if (matchingDeferApprover) {
        this.oddDeferApprover = null;
      } else {
        this.oddDeferApprover = action.deferApprovedByUser;
        this.deferApproverDropdown.push({ valueExp: action.deferApprovedByUser, displayExp: action.deferApprover });
      }
    }
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  isAllBusinessAreaSelected = false;
  @ViewChild('actionType') actionType: MatSelect;
  isAllActionTypeSelected = false;
  public toggleAllSelection(value: any): void {
    if (value == 'business-area') {
      if (this.isAllBusinessAreaSelected) {
        this.businessArea.options.forEach((item: MatOption) => item.select());
      } else {
        this.businessArea.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'action-type') {
      if (this.isAllActionTypeSelected) this.actionType.options.forEach((item: MatOption) => item.select());
      else {
        this.actionType.options.forEach((item: MatOption) => item.deselect())
        this.selectedActionType = [];
      }
      setTimeout(() => { this.handleDropDownValidation('action-type', this.selectedActionType) });
    }
  }

  public cancelAddOrEditPopup(): void {
    this.qualityService.getQmsActionDataUsingById.status = undefined;
    this.visibleAddAndEditPopup.close();
  }

  private setAesthetic(action: any) {
    this.isPlanFrozen = false;
    this.isExecutionFrozen = false;

    if (action.status == 'Open' || action.status == 'Plan Review Rejected' || action.status == 'Plan Approval Rejected') {
      this.isPlanFrozen = !this.message.showPreActionsActionButtons;
      this.isExecutionFrozen = true;
    } else if (action.status == 'In Progress' || action.status == 'Implementation Review Rejected' || action.status == 'Implementation Approval Rejected' || action.status == 'Deferred(Review Rejected)' || action.status == 'Deferred(Approval Rejected)') {
      this.isPlanFrozen = true;
      this.isExecutionFrozen = this.action.assignedToUser != +this.message.getUserId();
    } else {
      this.isPlanFrozen = true;
      this.isExecutionFrozen = true;
    }

    this.message.showDocumentActionButtons = !this.isPlanFrozen || !this.isExecutionFrozen;
  }

  public async addOrEdit(action: any): Promise<boolean> {
    this.isProcessing = true;

    const module = this.qualityService.moduleName;
    const status = this.qualityService.activity.status;

    const secondLevel = !['Open', 'Pending Plan Review', 'Plan Review Rejected', 'Pending Plan Approval', 'Plan Approval Rejected'].includes(this.action.status) && status == 'In Progress';

    if (status == 'In Progress') {
      const locked = await this.qualityService.validateExtension({
        refNo: this.qualityService.activityId,
        extensionFor: "Action",
        subTaskNo: this.action.actionId
      });

      if (locked) {
        setTimeout(() => { this.showSnackBar(this.qualityService.extensionResult, 'E') }, 0);
        this.isProcessing = false;
        return false;
      }
    }

    this.isProcessing = false;

    const validations: any[] = [];
    if (this.searchUsersComponent.isSwitchingUser) {
      validations.push([]);
    } else {
      validations.push(
        { condition: !action.actionName, id: 'action-name' },
        { condition: !action.actionAt && module != 'CC', id: 'action-at' },
        { condition: module != 'CC' && (this.isBusinessAreaEmpty ? !this.selectedBusinessArea : !this.selectedBusinessArea.length), id: 'business-area' },
        { condition: !action.targetDate, id: 'target-date' },
        { condition: !action.assignedTo, id: 'assigned-to' },
        { condition: secondLevel && action.actionPerformed && !action.performedActionDetails, id: 'action-performed' },
        { condition: module == 'CAPA' && !this.selectedActionType.length, id: 'action-type' },
      );
    }

    const invalidIds = validations.filter(v => v.condition).map(v => v.id);
    if (invalidIds.length > 0) {
      setTimeout(() => {
        this.mandatoryValidation(invalidIds);
        this.showSnackBar('Please enter all mandatory fields', 'E');
      })
      this.isProcessing = false;
      return false;
    }

    const obj = this.buildObject(action);

    this.isProcessing = true;
    try {
      if (this.visibleEditButton) {
        return await this.update(obj);
      } else {
        return await this.create(obj);
      }
    } finally {
      this.isProcessing = false;
    }
  }

  public mandatoryValidation(elementIds: any): void {
    for (const elementId of elementIds) {
      const element = document.getElementById(elementId) as HTMLInputElement | null;
      if (element) {
        element.style.color = 'red';
      } else {
        console.error('Unable to find the element. [onNgModuleChange()] Id → ', element);
      }
    }
  }

  private buildObject(action: any) {

    const isNotCC: boolean = this.qualityService.moduleName != 'CC';
    let coreBusinessArea: string | null = null;

    if (isNotCC) {
      if (this.isBusinessAreaEmpty) {
        coreBusinessArea = this.selectedBusinessArea;
      } else {
        coreBusinessArea = this.selectedBusinessArea?.join(',');
      }
    }

    return {
      refNo: this.qualityService.activityId,
      module: this.qualityService.moduleName,
      actionAt: action.actionAt,
      actionName: action.actionName,
      actionDescription: action.actionDescription,
      coreBusinessArea: coreBusinessArea,
      assignedToUser: action.assignedToUser,
      assignedToDepartment: action.assignedToDepartment,
      targetDate: action.targetDate ? this.appService.dateZoneConvertion(new Date(action.targetDate)) : null,
      comments: action.comments,
      actionPerformed: action.actionPerformed ? "Y" : "N",
      performedActionDetails: action.performedActionDetails,
      justification: action.justification,
      actualActionCompletedOn: action.actualActionCompletedOn ? this.appService.dateZoneConvertion(new Date(action.actualActionCompletedOn)) : null,
      reviewedByUser: action.reviewedByUser == 0 ? 0 : action.reviewedByUser,
      approvedByUser: action.approvedByUser == 0 ? 0 : action.approvedByUser,
      deferReviewedByUser: action.deferReviewedByUser == 0 ? 0 : action.deferReviewedByUser,
      deferApprovedByUser: action.deferApprovedByUser == 0 ? 0 : action.deferApprovedByUser,
      planReviewedBy: action.planReviewedBy == 0 ? 0 : action.planReviewedBy,
      planApprovedBy: action.planApprovedBy == 0 ? 0 : action.planApprovedBy,
      ... this.qualityService.moduleName == 'CAPA' && { actionType: this.selectedActionType.join(',') }
    };
  }

  private create(action: any): Promise<boolean> {
    return firstValueFrom(this.appService.createPreAction(action))
      .then((res: any) => {
        if (res.resultType == "S") {
          this.getCall();
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(res.result, res.resultType);
          return true;
        }
        this.showSnackBar(res.result, res.resultType);
        return false;
      })
      .catch(() => {
        this.showSnackBar("Error occurred", 'E');
        return false;
      });
  }

  private update(action: any): Promise<boolean> {
    const obj = { ...action, actionId: this.action.actionId, slNo: this.action.slNo };

    return firstValueFrom(this.appService.updatePreAction(obj))
      .then((res: any) => {
        if (res.resultType == "S") {
          this.getCall();
          this.action.ACTION_ID = this.action.actionId;
          this.openEditPopup(this.action, 0, "view");
          if (this.isFromDynamicClick) {
            this.isFromDynamicClick = false;
          } else {
            this.showSnackBar(res.result, res.resultType);
          }

          if (this.isSwitchingUser) {
            this.switchUserComponent.cancelSwitchUserPopup();
            this.switchUserComponent.closeConfirmationPopup();
            this.isSwitchingUser = false;
          }
          return true;
        }
        this.showSnackBar(res.result, res.resultType);
        return false;
      })
      .catch((err) => {
        console.error('Update PreAction failed:', err);
        this.showSnackBar("Error occurred while updating", 'E');
        return false;
      });

  }

  public performOperation(): void {
    const validations: any[] = [];
    const button = this.buttonLabel;
    const action = this.action;

    validations.push(
      { condition: (button == 'Submit for Plan Review' || button == 'Re-Submit for Plan Review') && !action.planReviewedBy, id: 'p-plan-reviewer' },
      { condition: (button == 'Submit for Plan Review' || button == 'Re-Submit for Plan Review') && action.planApprovedBy != 0 && !action.planApprovedBy, id: 'p-plan-approver' },
      { condition: (button == 'Submit for Plan Approve' || button == 'Re-Submit for Plan Approve') && !action.planApprovedBy, id: 'p-plan-approver' },
      { condition: (button == 'Submit for Implementation Review' || button == 'Re-Submit for Implementation Review') && !action.reviewedByUser, id: 'p-reviewer' },
      { condition: (button == 'Submit for Implementation Review' || button == 'Re-Submit for Implementation Review') && action.approvedByUser != 0 && !action.approvedByUser, id: 'p-approver' },
      { condition: (button == 'Submit for Implementation Approve' || button == 'Re-Submit for Implementation Approve') && !action.approvedByUser, id: 'p-approver' },
      { condition: ((this.buttonLabel == 'Review' || this.buttonLabel == 'Plan Review' || this.buttonLabel == 'Plan Approve' || this.buttonLabel == 'Approve') && this.selectedStatus.includes("Rejected") && !this.reason), id: 'reason' },
      { condition: localStorage.getItem("adEnabled") != 'Y' && !this.password, id: 'password' },
      { condition: (button == 'Plan Review' || button == 'Plan Approve' || button == 'Review' || button == 'Approve') && !this.selectedStatus, id: 'radio-status' },
      { condition: (button == 'Defer Action' || button == 'Re-Submit for Defer Action') && !this.reason, id: 'reason' },
      { condition: (button == 'Defer Action' || button == 'Re-Submit for Defer Action') && !this.action.deferReviewedByUser, id: 'p-defer-reviewer' },
      { condition: (button == 'Defer Action' || button == 'Re-Submit for Defer Action') && !this.action.deferApprovedByUser, id: 'p-defer-approver' },
      { condition: !action.actionAt && this.qualityService.moduleName != 'CC', id: 'action-at' },
      { condition: this.qualityService.moduleName != 'CC' && (this.isBusinessAreaEmpty ? !this.selectedBusinessArea : !this.selectedBusinessArea.length), id: 'business-area' },
    );

    this.setNext(validations.filter(v => v.condition).map(v => v.id));
  }

  private setNext(array: any[]): void {
    if (array.length > 0) {
      this.mandatoryValidation(array);
      setTimeout(() => this.showSnackBar('Please enter all mandatory fields!', 'E'));

    } else if (this.buttonLabel == "Review" || this.buttonLabel == "Plan Review" || this.buttonLabel == "Approve" || this.buttonLabel == "Plan Approve" || this.buttonLabel == "Submit for Implementation Review" || this.buttonLabel == "Submit for Plan Review" || this.buttonLabel == "Submit for Implementation Approval" || this.buttonLabel == "Submit for Plan Approval") {
      this.validateUserAndExecute();

    } else {
      this.execute();
    }
  }

  public cancelReasonPopup(): void {
    this.isFromDynamicClick = false;
    this.visiblePerformOperationPopup.close();
  }

  public async dynamicButtonClick(button: any): Promise<void> {
    const status = this.qualityService.activity.status;

    if ((status == "In Progress") && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Action", subTaskNo: this.action.actionId })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else {

      this.isFromDynamicClick = true;
      const isValid = await this.addOrEdit(this.action);
      if (!isValid) return;

      await this.waitForPreliminaryActions(() => { return !!(this.action?.status && this.action?.actionId != null) }, 10000);

      this.isProcessing = false;
      this.buttonLabel = button;
      this.selectedStatus = '';
      this.reason = "";
      this.password = "";
      this.userName = localStorage.getItem("loggedUserName")!;
      this.isESignRequired = false;
      this.isReasonSignReqd = true;
      this.isESignRequired = true;
      this.hidePassword = true;
      let array: [] = [];
      if (button == "Delete") {
        this.action.deleteReason = null;
        this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
      } else {
        if (button == "Review" || button == "Plan Review") {
          this.reviewStatus = ['Reviewed', 'Review Rejected'];
        } else if (button == "Approve" || button == "Plan Approve") {
          this.reviewStatus = ['Approved', 'Approval Rejected'];
        }
        this.isProcessing = true;
        this.appService.getDocumentsForActions(this.qualityService.activityId, this.message.subModuleId).subscribe((response: any) => {
          array = response;
          this.isProcessing = false;
          if ((button == 'Submit for Implementation Review' || button == 'Submit for Implementation Approval' || button == 'Mark as Completed') && !this.action.actionPerformed) {
            this.showSnackBar("The action to be performed before Submit for Implementation Review", "E");
          } else if ((button == 'Submit for Implementation Review' || button == 'Submit for Implementation Approval' || button == 'Mark as Completed') && (this.action.actionPerformed && !this.action.performedActionDetails)) {
            this.showSnackBar("Please enter Performed Action Details", "E");
          } else if ((button == 'Submit for Implementation Review' || button == 'Submit for Implementation Approval' || button == 'Mark as Completed') && this.action.actionPerformed && !array.length) {
            this.showSnackBar("Please add supporting documents for Actions", "E");
          } else if (this.action.actionPerformed && (button == 'Defer Action' || button == "Re-Submit for Defer Action")) {
            this.showSnackBar('Action Performed toggle button should be disabled in order to Defer', "E");
          } else {
            if (button == 'Submit for Implementation Review' || button == 'Submit for Implementation Approval' || button == 'Mark as Completed') {
              this.action.deferReviewedByUser = this.action.deferApprovedByUser = null;
            }
            this.visiblePerformOperationPopup = this.dialog.open(this.performOperationPopup, this.performOperationPopupConfig);
          }
        })
      }
    }
  }

  private async getButtonOperation() {
    if (this.buttonLabel === "Review" || this.buttonLabel === "Approve") {
      return this.selectedStatus;
    } else if (this.buttonLabel === "Plan Review" || this.buttonLabel === "Plan Approve") {
      if (this.selectedStatus == 'Reviewed' || this.selectedStatus == 'Approved') {
        return this.selectedStatus;
      } else {
        return this.buttonLabel === "Plan Review" ? 'Plan Review Rejected' : 'Plan Approval Rejected';
      }
    } else {
      return this.buttonLabel;
    }
  }

  private async execute() {

    const data = {
      actionId: this.action.actionId,
      currentStatus: this.action.status,
      buttonOperation: await this.getButtonOperation(),
      comments: this.reason,
    };

    this.isFromDynamicClick = true;
    const isValid = await this.addOrEdit(this.action);
    if (!isValid) return;

    await this.waitForPreliminaryActions(() => { return !!(this.action?.status && this.action?.actionId != null) }, 10000);

    this.appService.performPreAction(data).subscribe((Response: any) => {
      if (Response.resultType == "S") {
        this.action.ACTION_ID = this.message.subModuleId;
        this.visiblePerformOperationPopup.close();
        this.openEditPopup(this.action, 0, "view");
        this.getCall();
      } else {
        this.isProcessing = false;
      }
      this.showSnackBar(Response.result, Response.resultType);
    });
  }

  validateUserAndExecute() {
    if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable();
    } else {
      let data = { userName: this.userName, password: this.password }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {
          this.isProcessing = true;
          this.execute();
        } else {
          this.showSnackBar(data.result, data.resultType);
          this.isProcessing = false;
        }
      })
    }
  }

  authEnable() {
    this.authService.loginPopup({ scopes: ["User.Read"], prompt: "login" }).subscribe({
      next: (result) => {
        let oldLoginUser = localStorage.getItem("loggedUserName")?.toUpperCase();
        let newUser = result.account?.username.toUpperCase();
        if (oldLoginUser === newUser) {
          this.execute();
        }
      },
      error: (error) => {
        this.isProcessing = false;
      }
    });
  }

  waitForPreliminaryActions(checkFn: () => boolean, timeout = 10000, interval = 100): Promise<void> {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const timer = () => {
        if (checkFn()) {
          resolve();
        } else if (Date.now() - start >= timeout) {
          reject(new Error('Timeout: Preliminary Action not fully populated.'));
        } else {
          setTimeout(timer, interval);
        }
      };
      timer();
    });
  }

  public deleteFunction(action: any): void {

    if (action.deleteReason) {
      let obj: {} = this.buildObject(action);

      obj = { ...obj, actionId: this.action.actionId, slNo: this.action.slNo, deleteReason: action.deleteReason };

      this.isProcessing = true;
      this.appService.deletePreAction(obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.visibleAddAndEditPopup.close();
            this.visibleDeletePopup.close();
            this.getCall();
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      setTimeout(() => this.showSnackBar("Please enter the Delete Reason", 'E'))
    }
  }

  public cancelDeletePopup(): void {
    this.visibleDeletePopup.close();
  }

  showPassword() {
    this.hidePassword = !this.hidePassword;
  }

  @ViewChild(SearchUsersComponent) searchUsersComponent!: SearchUsersComponent;
  searchAssignTo(workingFor: string) {
    this.searchUsersComponent.popupTitle = 'Assign To';
    this.searchUsersComponent.isSwitchingUser = this.isSwitchingUser = workingFor == 'switch';
    this.searchUsersComponent.isSwitchingUser && (this.message.switchUserCurrentValue = this.action.assignedToUser);
    this.searchUsersComponent.selectionMode = 'single';
    this.searchUsersComponent.trigger();
  }

  onSearchUserEmitted() {
    this.action.assignedToUser = this.qualityService.selectedSearchUserId;
    this.action.assignedTo = this.qualityService.selectedSearchUserName;
    if (this.searchUsersComponent.isSwitchingUser) {
      this.addOrEdit(this.action);
    }
  }

  onChildValueEmit() {
    this.getCall();
    this.getDynamicLabel();
  };

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  editorValue: any;
  editorTitle: any;
  allowEditing: boolean = false;
  openEditor(value: string, icon: string) {
    const editorTitleMapping: Record<string, any> = {
      'CR': this.qualityService.activityDynamicLabel?.['CHANGE_DESCRIPTION']?.fieldName,
      'CAPA': this.qualityService.activityDynamicLabel?.['CAPA_DESCRIPTION']?.fieldName,
      'DV': this.qualityService.activityDynamicLabel?.['DV_DESCRIPTION']?.fieldName,
      'IN': this.qualityService.activityDynamicLabel?.['DESCRIPTION']?.fieldName,
      'QI': this.qualityService.activityDynamicLabel?.['DESCRIPTION']?.fieldName,
      'CC': this.qualityService.activityDynamicLabel?.['COMPLAINT_DESCRIPTION']?.fieldName,
    };

    const editorValueMapping: Record<string, any> = {
      'CR': this.qualityService.activity.changeDescription,
      'CAPA': this.qualityService.activity.capaDescription,
      'DV': this.qualityService.activity.dvDescription,
      'IN': this.qualityService.activity.description,
      'QI': this.qualityService.activity.description,
      'CC': this.qualityService.activity.complaintDescription,
    };

    this.allowEditing = icon == 'edit';

    if (value == "Action Description") {
      this.editorTitle = this.dynamicLabel['ACTION_DESCRIPTION']?.fieldName;
      this.editorValue = this.action.actionDescription || '';
    } else if (value == "Performed Action Details") {
      this.editorTitle = this.dynamicLabel['PERFORMED_ACTION_DETAILS']?.fieldName;
      this.editorValue = this.action.performedActionDetails || '';
    } else {
      this.editorTitle = editorTitleMapping[this.qualityService.moduleName];
      this.editorValue = editorValueMapping[this.qualityService.moduleName];
    }
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  saveEditor(editorValue: any) {
    const formattedTitle = this.editorTitle
      .split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
    if (this.editorTitle == "Action Description") {
      this.action.actionDescription = this.editorValue;
    } else if (this.editorTitle == "Performed Action Details") {
      this.action.performedActionDetails = this.editorValue;
    } else {
      this.qualityService.activity[formattedTitle] = this.editorValue;
    };

    this.visibleEditor.close();
  }

  cancelEditor() {
    this.visibleEditor.close();
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }

  private showSnackBar(message: string, type: string): void {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe({
      next: () => {
        this.snackbarRef.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
    })
  }

  label: any = [];
  dynamicLabel: any = null;
  private getDynamicLabel(): void {
    this.isProcessing = true;
    const data = {
      tableName: 'QMS_PRE_ACTIONS_VW',
      moduleName: this.qualityService.moduleName,
      gridName: 'PRE_ACTIONS',
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  @ViewChild(SwitchuserComponent) switchUserComponent!: SwitchuserComponent;
  userId: any;
  isSwitchingUser: boolean = false;
  openSwitchUser(value: any) {
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = "PreAction";
    this.message.switchuserRole = value;
    this.isSwitchingUser = true;
    this.message.switchComparisonUser = null;

    if (value == "Plan Reviewer") {
      this.message.switchUserCurrentValue = this.message.switchedUser = this.userId = this.action.planReviewedBy;
      this.message.switchUserdropDownList = this.reviewerDropdown;
    } else if (value == "Plan Approver") {
      this.message.switchUserCurrentValue = this.message.switchedUser = this.userId = this.action.planApprovedBy;
      this.message.switchUserdropDownList = this.approverDropdown;
    } else if (value == "Reviewer") {
      this.message.switchUserCurrentValue = this.message.switchedUser = this.userId = this.action.reviewedByUser;
      this.message.switchUserdropDownList = this.reviewerDropdown;
    } else if (value == "Approver") {
      this.message.switchUserCurrentValue = this.message.switchedUser = this.userId = this.action.approvedByUser;
      this.message.switchUserdropDownList = this.approverDropdown;
    } else if (value == "Defer Reviewer") {
      this.message.switchComparisonUser = this.action.assignedToUser;
      this.message.switchUserCurrentValue = this.message.switchedUser = this.userId = this.action.deferReviewedByUser;
      this.message.switchUserdropDownList = this.deferReviewerDropdown;
    } else if (value == "Defer Approver") {
      this.message.switchComparisonUser = this.action.assignedToUser;
      this.message.switchUserCurrentValue = this.message.switchedUser = this.userId = this.action.deferApprovedByUser;
      this.message.switchUserdropDownList = this.deferApproverDropdown;
    }
    this.switchUserComponent.openswitchuser(value, 'Pre Action');
  };

  onChildValueEmitted() {
    if (this.message.switchuserRole == "Plan Reviewer") {
      this.action.planReviewedBy = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Plan Approver") {
      this.action.planApprovedBy = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Reviewer") {
      this.action.reviewedByUser = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Approver") {
      this.action.approvedByUser = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Defer Reviewer") {
      this.action.deferReviewedByUser = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Defer Approver") {
      this.action.deferApprovedByUser = this.message.switchedUser;
    }
    this.addOrEdit(this.action);
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  closeHtmlContent() {
    this.visibleClobPopup.close();
  }

  @ViewChild('reorderPopup', { static: true }) reorderPopup: TemplateRef<any>;
  visibleReorderPopup: MatDialogRef<TemplateRef<any>>;

  reorderPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  isReordered: boolean = false;
  openReorderPopup() {
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
    this.isReordered = false;
    this.visibleReorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
  }

  cancelReorder() {
    this.visibleReorderPopup.close();
  }

  dragAndDrop(event: CdkDragDrop<string[]>) {
    this.isReordered = true;
    moveItemInArray(this.grid, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
  }

  async reorderPreActions() {
    this.isProcessing = true;

    try {
      const tasks = this.grid.map(async (element: any) => {

        const actionDescription = await this.getClobValue(element.PRIM_IDENTIFIER, 'ACTION_DESCRIPTION');
        const performedActionDetails = await this.getClobValue(element.PRIM_IDENTIFIER, 'PERFORMED_ACTION_DETAILS');
        const justification = await this.getClobValue(element.PRIM_IDENTIFIER, 'JUSTIFICATION');

        const obj = {
          actionId: element.ACTION_ID,
          slNo: element.NEW_ORDER,
          refNo: element.REF_NO,
          module: element.MODULE,
          actionAt: element.ACTION_AT ?? null,
          actionName: element.ACTION_NAME,
          actionDescription,
          coreBusinessArea: element.CORE_BUSINESS_AREA,
          assignedToUser: element.ASSIGNED_TO_USER,
          assignedToDepartment: this.normalize(element.ASSIGNED_TO_DEPARTMENT),
          targetDate: element.TARGET_DATE ? this.appService.dateZoneConvertion(new Date(element.TARGET_DATE)) : null,
          comments: this.normalize(element.COMMENTS),
          actionPerformed: element.ACTION_PERFORMED ? 'Y' : 'N',
          performedActionDetails,
          justification,
          actualActionCompletedOn: element.ACTUAL_ACTION_COMPLETED_ON ? this.appService.dateZoneConvertion(new Date(element.ACTUAL_ACTION_COMPLETED_ON)) : null,
          reviewedByUser: this.normalize(element.REVIEWED_BY_USER),
          approvedByUser: this.normalize(element.APPROVED_BY_USER),
          deferReviewedByUser: this.normalize(element.DEFER_REVIEWED_BY_USER),
          deferApprovedByUser: this.normalize(element.DEFER_APPROVED_BY_USER),
          planReviewedBy: this.normalize(element.PLAN_REVIEWED_BY),
          planApprovedBy: this.normalize(element.PLAN_APPROVED_BY),
          actionType: this.normalize(element.ACTION_TYPE)
        };

        await this.executeReorder(obj);
      });

      await Promise.all(tasks);

      this.isReordered = false;
      this.ngOnInit();
      this.visibleReorderPopup.close();
      this.showSnackBar('Preliminary Actions reordered successfully', 'S');

    } catch (error: any) {
      console.error(error);
      this.showSnackBar('An error occurred while reordering Preliminary Actions.', 'E');
    } finally {
      this.isProcessing = false;
    }
  }

  private async executeReorder(obj: any): Promise<void> {
    const res: any = await firstValueFrom(this.appService.updatePreAction(obj));
    if (res.resultType !== 'S') {
      throw new Error(res.result);
    }
  }

  private async getClobValue(primeIdentifier: string, columnName: string): Promise<string> {
    const docObj = {

      primeIdentifier,
      tableView: 'QMS_PRE_ACTIONS_VW',
      columnName
    };

    const response: any = await firstValueFrom(this.appService.getClobToViewAudit(docObj));
    return response.result;
  }

  private normalize(v: any): any {
    if (v === '') return null;
    if (v === 0 || v) return v;
    return null;
  }


  @ViewChild('dynamicGridPopup', { static: true }) dynamicGridPopup: TemplateRef<any>;
  visibleDynamicGridPopup: MatDialogRef<TemplateRef<any>>;
  dynamicGridPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '1px', left: '7%' },
    maxWidth: '91vw',
  };

  dynamicGridData: any;
  openDynamicGrid(list: any) {
    this.dynamicGridData = {
      actionId: list.ACTION_ID,
      gridName: 'PRE_ACTIONS',
      pageName: 'Action-Extension'
    };
    this.visibleDynamicGridPopup = this.dialog.open(this.dynamicGridPopup, this.dynamicGridPopupConfig);
  };

  dynamicGridCancel() {
    this.visibleDynamicGridPopup.close();
  }

  onActionPerformedChange() {
    this.action.performedActionDetails = null;
    this.action.justification = null;
    this.action.actualActionCompletedOn = null;
  }

  getDynamicDescriptionLabel(): string {
    const labels = this.qualityService.activityDynamicLabel;

    const config: Record<string, { key: string; fallback: string }> = {
      CR: { key: 'CHANGE_DESCRIPTION', fallback: 'Change Description' },
      CAPA: { key: 'CAPA_DESCRIPTION', fallback: 'CAPA Description' },
      DV: { key: 'DV_DESCRIPTION', fallback: 'Deviation Description' },
      IN: { key: 'DESCRIPTION', fallback: 'Incident Description' },
      QI: { key: 'DESCRIPTION', fallback: 'Quality Issue Description' },
      CC: { key: 'COMPLAINT_DESCRIPTION', fallback: 'Customer Complaint Description' }
    };

    const moduleConfig = config[this.qualityService.moduleName];
    return moduleConfig ? labels?.[moduleConfig.key]?.fieldName ?? moduleConfig.fallback : 'Description';
  }

}
